<template>
	<div class="recursive-input-box" :class="[isLastLevel ? 'last-level' : '', data.required ? 'required1' : '', data.errorText ? 'error' : '']">
		<!-- 当前层级是最后一级时显示 el-input -->
		<template v-if="isLastLevel">
		<!-- {{ data.type }}{{ data.required }} -->
			<el-date-picker class="shuxing_input" v-if="data.oneOfValue != null && data.oneOfValue == 'date'"
				v-model="data.value" 
				format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				<!-- :placeholder="'请选择' + (data.titleChinese ? data.titleChinese : '')" -->
			</el-date-picker>
			<el-input :disabled="isChakan || system < 5"
				v-else-if="data.enumValue == null && data.type == 'string' || data.type == 'array'"
				class="shuxing_input" autosize 
				v-model="data.value" show-word-limit :type="data.maxLength == null ? 'input' : 'textarea'"
				:maxlength="data.maxLength" @input="handleInput(data)">
				<!-- :placeholder="'请输入' + (data.titleChinese ? data.titleChinese : '')" -->
			</el-input>
			<el-input :disabled="isChakan || system < 5"
				v-else-if="data.type == 'integer' || data.type == 'number' && data.enumValue == null"
				class="shuxing_input" 
				v-model="data.value" :max="data.maximum" @input="handleInput(data)"
				:maxlength="data.maxLength">
				<!-- :placeholder="'请输入' + (data.titleChinese ? data.titleChinese : '')" -->
			</el-input>
			<el-select :router="true" class="shuxing_input" v-else-if="data.property != 'marketplace_id'"
				v-model="data.value" clearable filterable
				>
				<!-- :placeholder="'请选择' + (data.titleChinese ? data.titleChinese : '')" -->
				<el-option v-for="selectItem in getOptions(data)"
					:key="selectItem" :label="selectItem" :value="selectItem">
				</el-option>
			</el-select>
			<!-- <div class="tip1" v-if="data.errorText">{{ data.errorText }}</div> -->

		</template>
		<!-- 如果有子级，递归渲染子组件 -->
		<template v-else>
			<div v-for="child in data.children" :key="child.id" class="recursive-input-box1"
				 :class="[isLastLevel ? 'last-level' : '', data.required ? 'required1' : '', data.errorText ? 'error' : '']">
				<span class="title" :class="'title' + level" >{{ child.titleChinese ? child.titleChinese + '（' + child.property + '）' : child.property }}</span>
				<new-recursive-input :data="child" :isChakan="isChakan" :system="system" :parent="data"
					:purchasable_offer_data="getData(child.property)"
					:level="parent && parent.titleChinese ? level + 1 : level" @input="$emit('input', $event)"></new-recursive-input>
			</div> 
		</template>
	</div>
</template>

<script>
export default {
	name: "NewRecursiveInput",
	props: {
		data: {
			type: Object,
			required: true,
		},
		isChakan: {
			type: Boolean,
			default: false,
		},
		system: {
			type: Number,
			default: 5,
		},
		parent: {
			type: Object,
			default: null,
		},
		purchasable_offer_data: {},
		level: {
			type: Number,
			default: 0
		},

	},
	data() {
		return {
		};
	},
	computed: {
		// 判断当前层级是否为最后一级
		isLastLevel() {
			if(!this.data.children || this.data.children.length === 0){
				this.$emit('input', this.data);
			}
			return !this.data.children || this.data.children.length === 0;
		},
	},
	mounted() {
		const lastLevel = document.querySelectorAll('.last-level');
		for (let i = 0; i < lastLevel.length; i++) {
			lastLevel[i].parentElement.style.display = 'flex';
			lastLevel[i].parentElement.style['alignItems'] = 'center';
		}
	},
	methods: {
        getOptions(data){
            if(data.enumValue){
                return data.enumValue;
            }else if(data.property){
                return JSON.parse(data.property);
            }else{
                return [];
            }
        },
		handleInput(items){
			if(items.type === 'integer'){
				if(items.value){
					const val = +items.value.replace(/[^\d]/g, '')
					this.$set(items, 'value', val);
				}
			}
			if(items.type === 'number' || items.type === 'integer'){
				if (items.maximum != null) {
					if (parseFloat(items.value) > items.maximum) {
						items.value = items.maximum;
						this.$set(items, 'value', items.maximum);
					}
				}
			}
            if(items.value){
                this.$set(items, 'value', +items.value);
            }
			this.$emit('input', items);
		},
		// numberInput(items) {
		// 	if(items.type === 'integer'){
		// 		this.$set(items, 'value', items.value.replace(/[^\d]/g, ''));
		// 	}
		// 	if (items.maximum != null) {
		// 		if (parseFloat(items.value) > items.maximum) {
		// 			items.value = items.maximum;
		// 			this.$set(items, 'value', items.maximum);
		// 		}
		// 	}
		// },
		getData(property) {
			if (this.purchasable_offer_data && this.purchasable_offer_data[property]) {
				return Array.isArray(this.purchasable_offer_data[property]) ? this.purchasable_offer_data[property][0] : this.purchasable_offer_data[property]
			}
			return null
		}
	},
};
</script>

<style scoped lang="scss">
.shuxing_input {
	width: 100%;
	// padding: 5px 0px;
}
.title {
	height: 40px;
	line-height: 40px;
}

.last-level {
	display: inline-block;
	margin-left: 10px;
	flex: 1;
	// display: flex;
	// align-items: center;
	.tip1{
		color: #f56c6c;
		white-space: nowrap;
		font-size: 14px;
		height: 20px;
		line-height: 20px;
	}
	&.required1{
		&::after{
			// content: '*';
			// color: #f56c6c;
			// position: absolute;
			// left: -10px;
			// top: 50%;
			// transform: translateY(-50%);
		}
	}
	&.error{
		&::after{
			// content: '*';
			// color: #f56c6c;
		}
	}
}

.recursive-input-box {
	position: relative;
	padding-left: 40px;
}

.recursive-input-box::before {
	content: '';
	position: absolute;
	top: 0;
	left: 10px;
	width: 1px;
	height: 100%;
	background-color: #ccc;
}

.recursive-input-box1 {
	position: relative;
}

.recursive-input-box1::after {
	content: '';
	position: absolute;
	top: 20px;
	// top: 50%;
	// transform: translateY(-50%);
	left: -30px;
	width: 30px;
	height: 1px;
	background-color: #ccc;
}

.last-level::before {
	// height: 50%;
}
</style>
